import { ref } from 'vue'

// Use window global to ensure single instance across Vite HMR
if (!window.__toastState) {
  window.__toastState = {
    toasts: ref([]),
    toastId: 0
  }
}

const toasts = window.__toastState.toasts
const getNextId = () => ++window.__toastState.toastId

const addToast = (message, type = 'info', duration = 4000) => {
  const id = getNextId()
  toasts.value.push({ id, message, type })

  if (duration > 0) {
    setTimeout(() => {
      removeToast(id)
    }, duration)
  }

  return id
}

const removeToast = (id) => {
  const index = toasts.value.findIndex((t) => t.id === id)
  if (index > -1) {
    toasts.value.splice(index, 1)
  }
}

// Singleton toast object for direct use
const toast = {
  error: (message, duration = 4000) => addToast(message, 'error', duration),
  success: (message, duration = 4000) => addToast(message, 'success', duration),
  info: (message, duration = 4000) => addToast(message, 'info', duration),
  warning: (message, duration = 4000) => addToast(message, 'warning', duration),
}

// Composable for component use
export function useToast() {
  return {
    toasts,
    toast,
    removeToast,
  }
}

export { toast, toasts, removeToast }
